"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HodWebhookIMSchema = exports.HodWebhookSchema = exports.HodSubmissionAnswersSchema = void 0;
const z = __importStar(require("zod"));
exports.HodSubmissionAnswersSchema = z.object({
    disclosureId: z.string().min(1),
    // Trim: JotForm emails arrive with stray whitespace, which fails .email() downstream
    respondentEmail: z.string().trim().min(1),
    doYou22: z.string().min(1),
    pleaseDescribe: z.string(),
});
exports.HodWebhookSchema = z.object({
    id: z.string(),
    submissionId: z.string().min(1),
    formId: z.string().min(1),
    disclosureId: z.string().min(1),
    hodEmail: z.string().trim().email(),
    signoffStatusUpdated: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
exports.HodWebhookIMSchema = exports.HodWebhookSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
